module.exports = __webpack_public_path__ + "img/UI_common_framelabelBYB_01_a7d9b63a7.png";